import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './AdminDashboard.css';
import { FaHome, FaSignOutAlt, FaFileAlt } from 'react-icons/fa';

const AdminDashboard = () => {

    const [logout, setLogout] = useState(false);
    const [enquiries, setEnquiries] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        fetchEnquiries();
    }, []);

    const fetchEnquiries = async () => {
        setLoading(true);
        try {
            const response = await fetch("https://api.siddhabhairabistore.com/surbhi/get-enquiry");
            const data = await response.json();
            setEnquiries(data.result || []);
        } catch (error) {
            console.error("Error fetching enquiries:", error);
        } finally {
            setLoading(false);
        }
    };

    
    const stats = {
        totalEnquiries: enquiries.length,
        personal: enquiries.filter(e => e.loanType === "Personal Loan").length,
        business: enquiries.filter(e => e.loanType === "Business Loan").length,
        housing: enquiries.filter(e => e.loanType === "Housing & Consumer Loan").length,
        property: enquiries.filter(e => e.loanType === "Loan Against Property Loan").length
    };

    const handleLogout = () => {
        localStorage.removeItem("isLoggedIn");
        navigate("/admin-login");
        window.location.reload();
    };

    return (
        <>
            {/* LEFT SIDEBAR */}
            <div className='sidebar-left shadow-lg'>
                <span className='sidebar-icon tooltip-item' onClick={() => navigate('/dashboard')}>
                    <FaHome size={22} />
                    <span className='tooltip-text'>Dashboard</span>
                </span>
                <span className='sidebar-icon tooltip-item' onClick={() => navigate('/enquiry')}>
                    <FaFileAlt size={22} />
                    <span className='tooltip-text'>Enquiry</span>
                </span>
                <span className='sidebar-icon tooltip-item' onClick={() => setLogout(true)}>
                    <FaSignOutAlt size={22} className='text-danger'/>
                    <span className='tooltip-text'>Logout</span>
                </span>
            </div>

            {/* RIGHT SIDE CONTENT */}
            <div className='sidebar-right'>
                <div className='sidebar-right-inner'>

                    <h3 className='fw-bold mb-4 text-primary'>Admin Dashboard !</h3>

                    {loading ? (
                        <p>Loading data...</p>
                    ) : (
                        <>
                            {/* CARDS */}
                            <div className="row g-3">
                                <div className="col-md-3 col-sm-6">
                                    <div className="card text-center shadow-sm border-0">
                                        <div className="card-header bg-primary text-white fw-bold">Total Enquiries</div>
                                        <div className="card-body">
                                            <h2 className="card-title display-6">{stats.totalEnquiries}</h2>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-2 col-sm-6">
                                    <div className="card text-center shadow-sm border-0">
                                        <div className="card-header bg-success text-white fw-bold">Personal Loan</div>
                                        <div className="card-body">
                                            <h2 className="card-title display-6">{stats.personal}</h2>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-2 col-sm-6">
                                    <div className="card text-center shadow-sm border-0">
                                        <div className="card-header bg-warning text-white fw-bold">Business Loan</div>
                                        <div className="card-body">
                                            <h2 className="card-title display-6">{stats.business}</h2>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-2 col-sm-6">
                                    <div className="card text-center shadow-sm border-0">
                                        <div className="card-header bg-info text-white fw-bold"> Property Loan</div>
                                        <div className="card-body">
                                            <h2 className="card-title display-6">{stats.property}</h2>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-3 col-sm-6">
                                    <div className="card text-center shadow-sm border-0">
                                        <div className="card-header bg-danger text-white fw-bold">Housing & Consumer Loan</div>
                                        <div className="card-body">
                                            <h2 className="card-title display-6">{stats.housing}</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* RECENT ENQUIRIES */}
                            <h4 className='fw-bold mt-5 mb-3 text-secondary'>Recent Enquiries</h4>

                            <ul className="list-group shadow-sm">
                                {enquiries.slice(-5).reverse().map(item => (
                                    <li key={item.id} className="list-group-item d-flex justify-content-between align-items-center">
                                        <div>
                                            <strong>{item.name}</strong> <br />
                                            <small className="text-muted">{item.loanType}</small>
                                            <p className="mb-0 text-muted">{item.description}</p>
                                        </div>
                                        <span className="badge bg-primary rounded-pill">{item.phone}</span>
                                    </li>
                                ))}
                            </ul>
                        </>
                    )}
                </div>
            </div>

            {/* LOGOUT MODAL */}
            {logout && (
                <div className="dialog-outer">
                    <div className="dialog-inner text-center">
                        <p className="fs-5 fw-bold text-danger mb-4">Logout Admin?</p>
                        <button className="btn btn-danger px-4 py-2 me-3" onClick={handleLogout}>Yes</button>
                        <button className="btn btn-secondary px-4 py-2" onClick={() => setLogout(false)}>No</button>
                    </div>
                </div>
            )}
        </>
    );
};

export default AdminDashboard;
